import React, { createContext, useContext, useRef, ReactNode } from 'react';

type FPSContextType = {
  subscribe: (callback: (fps: number) => void) => void;
  unsubscribe: (callback: (fps: number) => void) => void;
  updateFPS: (fps: number) => void;
};

const FPSContext = createContext<FPSContextType | undefined>(undefined);

export const FPSProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const callbacks = useRef<((fps: number) => void)[]>([]);

  const subscribe = (callback: (fps: number) => void) => {
    callbacks.current.push(callback);
  };

  const unsubscribe = (callback: (fps: number) => void) => {
    callbacks.current = callbacks.current.filter(cb => cb !== callback);
  };

  const updateFPS = (fps: number) => {
    callbacks.current.forEach(cb => cb(fps));
  };

  return (
    <FPSContext.Provider value={{ subscribe, unsubscribe, updateFPS }}>
      {children}
    </FPSContext.Provider>
  );
};

export const useFPS = (): FPSContextType => {
  const context = useContext(FPSContext);
  if (!context) {
    throw new Error('useFPS must be used within an FPSProvider');
  }
  return context;
};
